<template>
  <modal
    name="complete-profile"
    :maxWidth="1200"
    width="100%"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    style="overflow-x: hidden"
  >
    <div class="card">
      <div class="card-body position-relative">
        <button
          type="button"
          class="btn close-button"
          @click="$modal.hide('complete-profile')"
        >
          <i class="fas fa-times"></i>
        </button>
        <div class="row">
          <div class="col-12 text-primary">
            <resource
              title="Ändern"
              resource="customerProfile"
              :original="customerProfile"
              :attributes="[
                {
                  name: 'sex',
                  label: 'Geschlecht',
                  type: 'SexSelector'
                },
                {
                  name: 'postcode',
                  label: 'PLZ',
                  type: 'PostcodeSelector'
                },
                {
                  name: 'birthday',
                  label: 'Geburtsdatum',
                  type: 'BirthdaySelector',
                  withRandomSelector: false,
                  onlyDate: true
                }
              ]"
              header-class="bg-primary"
              @resource-persisted="refresh()"
            >
              <div slot="title" class="text-light">
                Vervollständigen Sie ihr Profil bevor Sie
                {{ appCurrency }} kaufen können.
              </div>
            </resource>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    },
    customerProfile() {
      let profile = { ...Laravel.user.customer_profile };
      profile.update_url = profile.complete_url;
      return profile;
    }
  },
  methods: {
    refresh() {
      location.reload();
    }
  }
};
</script>
